module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content flex-col"
  }, [_c('span', {
    staticClass: "first-title",
    staticStyle: {
      "margin-left": "35px",
      "margin-right": "34px"
    }
  }, [_vm._v("电脑端微信使用小程序的方法（通用版）")]), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("方法一：使用「在电脑上打开」功能")]), _vm._v(" "), _c('span', {
    staticClass: "describe",
    staticStyle: {
      "margin": "5px 25px 11px 25px"
    }
  }, [_vm._v("\n      确保在电脑上已登录微信，点击小程序右上角【•••】，点击【在电脑上打开】（需要升级至最新版微信）\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "outer2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图4.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("方法二：打开手机正在浏览的小程序")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("\n      保证小程序在手机上是打开的状态，然后登录电脑版微信，点击左下角【手机】按钮，便可打开手机上正在浏览的小程序\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "outer3",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图3.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "second-title"
  }, [_vm._v("Windows版微信使用小程序的方法")]), _vm._v(" "), _c('span', {
    staticClass: "word4"
  }, [_vm._v("通过小程序面板打开小程序（仅支持Windows版）")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("\n      登录Windows版微信，点击左下角【小程序】图标，打开小程序，即可打开已添加或者已使用过的小程序\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图2.png'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word4"
  }, [_vm._v("将淘基因添加至「我的小程序」，后续访问更快捷")]), _vm._v(" "), _c('span', {
    staticClass: "describe"
  }, [_vm._v("点击小程序右上角【•••】，点击【添加的我的小程序】")]), _vm._v(" "), _c('img', {
    staticClass: "outer2",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'tinified/位图1.png'
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d7d88e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/ComputerSideUsage.vue
// module id = 1692
// module chunks = 8